/** @format */

import {useEffect, useState} from 'react'

type PendingField<T> = {
  isDirty: boolean
  value: T
  setValue: (newValue: T) => void
}

// usePendingField can be used to create controlled form inputs or selects
// that need to keep track of whether their values have been modified
// compared to an original value.
export function usePendingField<T>(originalValue: T): PendingField<T> {
  const [value, setValue] = useState(originalValue)

  useEffect(() => {
    setValue(originalValue)
  }, [originalValue])

  return {
    isDirty: value !== originalValue,
    value,
    setValue,
  }
}
